import AddPost from './AddPost';

export default AddPost;
